<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">
      <!-- Loading tabla -->
      <div
        class="d-flex justify-content-center w-100"
        style="margin-top: 110px"
        v-if="load"
      >
        <loading />
      </div>
      <!-- Botones -->
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2" v-else>

        <div class="w-100">
          <div class="d-flex" style="position: absolute;"                  
              :style="[
              zIndexModal 
                ? { 'z-index': '2 !important' }
                : { 'z-index': '1' },
            ]"> 
            <editar-simple-acuerdo-cliente-base
              :dataAux="dataEditSimple"
              :data="data"
              :load="loadingEditSimple"
              :limpiarChecks="limpiarChecks"
              :filtroColdtreatment="filtroColdtreatment"
              />

            <ver-historial-acuerdo-clientes-base-modal
              :data="dataHistorial"
              :load="thisLoading"
            />
            <generar-acuerdo-de-cliente-segun-filtros-modal
              :data="dataTableAux"
              :dataInicial="dataInicial"
              :getListaAcuerdosClientesBase="getListaAcuerdosClientesBase"
              />
            <!-- Editar multiples -->
            <editar-multiple-acuerdo-clientes-base
              :acuerdoClientesBaseArreglo="acuerdoClientesBaseArreglo"
              :data="data"
              :limpiarChecks="limpiarChecks"
              :vaciarClienteBase="vaciarClienteBase"
              :filtroColdtreatment="filtroColdtreatment"
              @click="getDataListas()"
            />


            <!-- Reemplazar -->
            <buscar-reemplazar-acuerdo-clientes-base-modal
              class="z-index-fixed"
              :data="dataTableAux"
              :dataInicial="dataInicial"
              :getListaAcuerdosClientesBase="getListaAcuerdosClientesBase"
              :vaciarClienteBase="vaciarClienteBase"
            />

            <Button
              :size="15"
              color="#E5801A"
              colorText="#ffffff"
              tooltip="Publicar Todos Según Filtros"
              icon="fas fa-eye"
              @click.native="
                publicarDespublicarAcuerdosClientesByBooleano(true)
              "
              round
              :width="30"
              class="mt-2 mb-3 mr-2"
              translate
            />

            <!-- Despublicar todos -->
            <Button
              :size="15"
              color="#dc3545"
              colorText="#ffffff"
              tooltip="Despublicar Todos Según Filtros"
              icon="fas fa-eye-slash"
              @click.native="
                publicarDespublicarAcuerdosClientesByBooleano(false)
              "
              round
              :width="30"
              class="mt-2 mb-3 mr-2"
              translate
            />

            <!-- Despublicar Seleccionados -->
            <Button
              :size="15"
              color="#11409d"
              colorText="#ffffff"
              tooltip="Publicar Seleccionados"
              icon="fas fa-eye"
              @click.native="
                publicarDespublicarAcuerdosClientesBySelected(true)
              "
              round
              :width="30"
              class="mt-2 mb-3 mr-2"
              translate
              :inactive="acuerdoClientesBaseArreglo.length < 1"
            />

            <!-- Despublicar Seleccionados -->
            <Button
              :size="15"
              color="#11409d"
              colorText="#ffffff"
              tooltip="Despublicar Seleccionados"
              icon="fas fa-eye-slash"
              @click.native="
                publicarDespublicarAcuerdosClientesBySelected(false)
              "
              round
              :width="30"
              class="mt-2 mb-3 mr-2"
              translate
              :inactive="acuerdoClientesBaseArreglo.length < 1"
            />

            <Button
              :size="15"
              color="#dc3545"
              colorText="#ffffff"
              tooltip="Eliminación seleccionado(s)"
              icon="fas fa-trash"
              round
              :width="30"
              @click.native="deleteCkecks()"
              class="mt-2 mb-3 mr-2"
              translate
            />

            <Button
              :size="15"
              color="#dc3545"
              colorText="#ffffff"
              tooltip="Eliminación Según Filtros"
              icon="fa fa-trash-alt"
              round
              :width="30"
              class="mt-2 mb-3 mr-2"
              @click.native="eliminarPorFiltros()"
              translate
              hidden
            />

            <filtro-acuerdos-clientes-base
              :getListaAcuerdosClientesBase="getListaAcuerdosClientesBase"
            />
          </div>
        </div>

        <!-- Data Table -->
        <new-data-table
          v-if="acciones.length > 0"
          customHeaders
          :headers="headers"
          :data="dataTableAux"
          :acciones="acciones"
          :max="10"
          paginacion
          buscar
          idtabla="lista_acuerdos_clientes_base"
          :seleccionar="obtenerFilaSeleccionada"
          :filaChekeada="obtenerFilaSeleccionada"
          check
          :vaciarArreglo="vaciarClienteBase"
        />

        <not-found-table
          v-else
          class="justify-content-center w-100 pt-5"
          :text="'No se encontraron registros de acuerdos de clientes base'"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Componentes
import NewDataTable from "../../common/NewDataTable";
import Button from "../../common/Button";
import Loading from "../../common/loading";
import GenerarAcuerdoDeClienteSegunFiltrosModal from "../../../components/modals/lineas/tarifas/GenerarAcuerdoDeClienteSegunFiltrosModal";
import FiltroAcuerdosClientesBase from "../../../components/filtros/lineas/tarifas/FiltroAcuerdosClientesBase";
import BuscarReemplazarAcuerdoClientesBaseModal from "../../modals/lineas/tarifas/acuerdos_clientes_base/BuscarReemplazarAcuerdoClientesBaseModal";
import EditarMultipleAcuerdoClientesBase from "../../../components/modals/lineas/tarifas/acuerdos_clientes_base/EditarMultipleAcuerdoClientesBase";
import EditarSimpleAcuerdoClienteBase from "../../../components/modals/lineas/tarifas/acuerdos_clientes_base/EditarSimpleAcuerdoClienteBase";
import VerHistorialAcuerdoClientesBaseModal from "../../../components/modals/lineas/tarifas/acuerdos_clientes_base/VerHistorialAcuerdoClientesBaseModal.vue";

// Constantes
import {
  getAcuerdosClientesBase,
  deleteTarifasAcuerdosClientesBase,
  deleteManyAcuerdosClienteBase,
  publicarDespublicarAcuerdosClienteBase,
  getAcuerdosClientesBaseByIds,
  listarTariffClientRecords,
  getListasAcuerdosBase
} from "@/constants/lineas";

// Not Found
import NotFoundTable from "../../../components/common/NotFoundTable";

// Toast
import VueToastify from "vue-toastify";
import { publicarDespublicarAcuerdosClientesByBooleano } from "../../../constants/lineas";

Vue.use(VueToastify);

export default {
  props: {
    data: { type: Array },
    dataInicial: { type: Array },
    load: { type: Boolean },
    getListaAcuerdosClientesBase: { type: Function, default: () => {} },
  },
  data() {
    return {
      headers: [
        { title: "Cliente", width: "20px" },
        { title: "Naviera", width: "20px" },
        { title: "Naviera Salida", width: "20px" },
        { title: "POL", width: "20px" },
        { title: "POD", width: "20px" },
        { title: "Desde", width: "20px" },
        { title: "Hasta", width: "20px" },
        { title: "Vigencia", width: "20px" },
        { title: "TT", width: "10px" },
        { title: "Pública (Venta)", width: "10px" },
        { title: "Neta (Costo)", width: "10px" },
        { title: "Margen", width: "10px" },
        { title: "Neta Cte.", width: "10px" },
        { title: "Descuento", width: "10px" },
        { title: "Unidad", width: "10px" },
        { title: "Producto", width: "35px" },
        { title: "Atmósfera", width: "35px" },
        { title: "Trat. frío", width: "35px" },
        { title: "Dias Libres Origen", width: "10px" },
        { title: "Dias Plug Origen", width: "10px" },
        { title: "Dias Libres Destino", width: "10px" },
        { title: "Dias Plug Destino", width: "10px" },
        { title: "Genset", width: "2px" },
        { title: "Get Out", width: "2px" },
        { title: "Comentarios", width: "240px" },
        { title: "Tipo Contrato", width: "70px" },
        { title: "Contrato + Número", width: "10px" },
        { title: "ID Tariff Line", width: "10px" },
        { title: "Acciones", width: "90px" }, 
      ],
      acciones: [],
      dataTableAux: this.data,
      acuerdoClientesBaseArreglo: [],
      dataEditSimple: [],
      loadingEditSimple: false,
      thisLoading: false,
      dataHistorial: [],
      filtroContenedores: [],
      filtroCommodity: [],
      filtroAtmosferas: [],
      filtroColdtreatment: [],
    };
  },
  components: {
    NewDataTable,
    Button,
    GenerarAcuerdoDeClienteSegunFiltrosModal,
    Loading,
    NotFoundTable,
    FiltroAcuerdosClientesBase,
    BuscarReemplazarAcuerdoClientesBaseModal,
    EditarMultipleAcuerdoClientesBase,
    EditarSimpleAcuerdoClienteBase,
    VerHistorialAcuerdoClientesBaseModal,
  },
  computed: {
    ...mapState(["loading", "loadingTable","zIndexModal"]),
    ...mapState("lineas", [ "selectCommodities", "selectAtmospheres", "selectContainers" ]),
  },
  methods: {
    ...mapActions(["ActionSetLoadingTable"]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosClientesBase",
      "actionSetVisibleModalEditarSimpleAcuerdoLinea",
      "actionSetVisibleModalVerHistorialClientesBase",
    ]),
    vaciarClienteBase() {
      this.acuerdoClientesBaseArreglo = [] ;
      // this.data = []
    },
    async eliminarPorFiltros() {
      if (this.dataTableAux.length === 0)
        return this.$vToastify.warning(
          "Debe haber registros para eliminar.",
          "!Precaución¡"
        );

      const response = await this.$vToastify.prompt({
        body: `¿Desea eliminar ${this.dataTableAux.length} Acuerdos Filtrados?`,
        answers: { Sí: true, No: false },
      });

      if (!response) return;

      const form = {
        acuerdoClientesBaseArreglo: this.dataTableAux.map((d) => d.data_complementaria.id),
      };

      this.$vToastify.loader("Eliminando Registros...");

      try {

        let { status, message } =  await deleteManyAcuerdosClienteBase(form);

        if (status === 200) {

          this.getListaAcuerdosClientesBase();

          this.$vToastify.stopLoader();

          this.$vToastify.success(message, "¡Realizado!");

        } else {

          this.$vToastify.stopLoader();

          this.$vToastify.error("Error al eliminar seleccionados, recargue la página y vuelva a intentar", "¡Error!");

        }


      } catch (error) {

        this.$vToastify.stopLoader();

        return this.$vToastify.error("Error al eliminar seleccionados, recargue la página y vuelva a intentar", "¡Error!");

      }
    },
    limpiarChecks() {
      this.acuerdoClientesBaseArreglo = [];
    },
    async deleteCkecks() {
      if (this.acuerdoClientesBaseArreglo.length === 0) {

        return this.$vToastify.warning(
          "Debe seleccionar Acuerdos para eliminar.",
          "!Precaución¡"
        );

      }

      const response = await this.$vToastify.prompt({
        body: `¿Desea eliminar ${this.acuerdoClientesBaseArreglo.length} acuerdos?`,
        answers: { Sí: true, No: false },
      });

      if (!response) return;

      const form = { acuerdoClientesBaseArreglo: this.acuerdoClientesBaseArreglo };

      this.$vToastify.loader("Eliminando Registros...");

      try {

        let { status, message } = await deleteManyAcuerdosClienteBase(form);

        if (status === 200) {

          await this.getListaAcuerdosClientesBase();

          this.$vToastify.stopLoader();

          this.$vToastify.success(message, "¡Realizado!");

          this.acuerdoClientesBaseArreglo = [];

        } else {

          this.$vToastify.stopLoader();

          this.$vToastify.error("Error al eliminar seleccionados, recargue la página y vuelva a intentar", "¡Error!");

        }

      } catch (error) {

        this.$vToastify.stopLoader();

        return this.$vToastify.error("Error al eliminar seleccionados, recargue la página y vuelva a intentar", "¡Error!");

      }
    },
    async generarBotonesAcciones() {

      this.acciones = [];

      this.dataTableAux.map((item) => {

        let options = [], published = Boolean(item.data_complementaria.published);

        options.push({
          icon: "fa fa-edit",
          title: "Editar",
          id: item
        });

        if (published === true) {

          options.push({
            icon: "fa fa-eye text-success",
            title: "Despublicar",
            id: item
          });

        } else {

          options.push({
            icon: "fa fa-eye-slash text-danger",
            title: "Publicar",
            id: item
          });

        }

        options.push({
          icon: "fa fa-search",
          title: "Ver historial",
          id: item
        });

        this.acciones.push(options);

      });

      await this.ActionSetLoadingTable(false);
    },
    async getDataListas() {

      let dataListas = await getListasAcuerdosBase();

      this.filtroContenedores = dataListas.filtro_contenedores;

      this.filtroCommodity = dataListas.lista_prod_categories;

      this.filtroAtmosferas = dataListas.lista_atmosferas;

      this.filtroColdtreatment = dataListas.lista_coldtreatment || [];

    },
    async obtenerFilaSeleccionada({ accion, estado, id }) {
      if (accion === "Editar") {
      
        this.loadingEditSimple = true;

        this.actionSetVisibleModalEditarSimpleAcuerdoLinea(true);

        const idAcuerdoCliente = parseInt( this.dataTableAux[id].data_complementaria.id);

        const { data_table } = await getAcuerdosClientesBaseByIds([
          idAcuerdoCliente,
        ]);

        this.dataEditSimple = data_table.map((al) => ({
          id: al.data_complementaria.id,
          cliente_id: {
            id: al.data_complementaria.cliente_id.id,
            name: al.data_complementaria.cliente_id.name,
          },
          naviera: {
            id: al.data_complementaria.naviera_id.id,
            name: al.data_complementaria.naviera_id.name,
          },
          naviera_salida: al.data[2],
          pod: {
            id: al.data_complementaria.pod.id,
            name: al.data_complementaria.pod.name,
          },
          pol: {
            id: al.data_complementaria.pol.id,
            name: al.data_complementaria.pol.name,
          },
          margin: al.data_complementaria.margin,
          neta_cliente: al.data_complementaria.neta_cliente,
          from_date: al.data_complementaria.from_date,
          to_date: al.data_complementaria.to_date,
          transit_time: al.data_complementaria.transit_time,
          neta: al.data_complementaria.neta,
          public_value: al.data_complementaria.public_value,
          vigencia: al.data_complementaria.vigencia,
          container_id: {
            id: +al.data_complementaria.container_id.id,
            code: al.data_complementaria.container_id.name,
          },
          products_category_id: {
            id: +al.data_complementaria.products_category_id.id,
            name: al.data_complementaria.products_category_id.name,
          },
          descuento:
            parseInt(al.data_complementaria.public_value) -
            parseInt(al.data_complementaria.neta),
          atmosphere_id: {
            id: +al.data_complementaria.atmosphere_id.id,
            name: al.data_complementaria.atmosphere_id.name
          },
          coldtreatment: al.data_complementaria.coldtreatment && al.data_complementaria.coldtreatment !== "-"
            ? {
                id: al.data_complementaria.coldtreatment_id || "",
                name: al.data_complementaria.coldtreatment,
              }
            : { id: "", name: "" },
          free_days_embark: al.data_complementaria.free_days_embark,
          plug_days_embark: al.data_complementaria.plug_days_embark,
          free_days_land: al.data_complementaria.free_days_land,
          plug_days_land: al.data_complementaria.plug_days_land,
          genset: al.data_complementaria.genset === "Si",
          get_out: al.data_complementaria.get_out,
          comment: al.data_complementaria.comment,
          tipo_contrato_id: {
            id: al.data_complementaria.tipo_contrato.id,
            name: al.data_complementaria.tipo_contrato.name,
          },
          tariff_contract: {
            id: al.data_complementaria.tariff_contract_id,
            name: al.data_complementaria.tariff_contract_name,
            contrato: `${ al.data_complementaria.tariff_contract_id.name } - ${ al.data_complementaria.tariff_contract_id.number }`,
          },
        }));

        this.loadingEditSimple = false;

      } else if (accion === "Despublicar" || accion === "Publicar") {

        const { data_complementaria } = this.dataTableAux[id];

        await this.publicarDespublicarAcuerdosClienteBase(data_complementaria);

      } else if (accion === "fila_chekeada") {

        const { data_complementaria } = this.dataTableAux[id];

        if (estado) {

          this.acuerdoClientesBaseArreglo.push(data_complementaria.id);

        } else {          

          this.acuerdoClientesBaseArreglo = this.acuerdoClientesBaseArreglo.filter( id => id !== data_complementaria.id);

        }

      } else if (accion === "Ver historial") {

        this.actionSetVisibleModalVerHistorialClientesBase(true);

        this.thisLoading = true;

        const idTariffClients = parseInt( this.dataTableAux[id].data_complementaria.id);

        const { data } = await listarTariffClientRecords(idTariffClients);

        this.dataHistorial = data.map((d) => ({
          data: [d.name, d.action, d.fecha],
        }));

        this.thisLoading = false;
      }
    },
    async publicarDespublicarAcuerdosClienteBase(data_complementaria) {
      const message = data_complementaria.published
        ? "Despublicar"
        : "Publicar";

      const response = await this.$vToastify.prompt({
        body: `¿Desea  ${message} acuerdos?`,
        answers: { Sí: true, No: false },
      });

      if (!response) return;

      const message_loading = data_complementaria.published
        ? "Despublicando..."
        : "Publicando...";

      const form = { id: data_complementaria.id };

      this.$vToastify.loader(message_loading);

      const message_response = data_complementaria.published
        ? "Despublicado"
        : "Publicado";

      try {
        await publicarDespublicarAcuerdosClienteBase(form);

        this.getListaAcuerdosClientesBase();
        this.$vToastify.stopLoader();

        this.$vToastify.success(
          `Acuerdo de Cliente Bases ${message_response} correctamente`,
          "¡Realizado!"
        );
      } catch (error) {
        this.$vToastify.stopLoader();

        return this.$vToastify.error(
          `Error al ${message}, recargue la página y vuelva a intentar`,
          "¡Error!"
        );
      }
    },
    async eliminarAcuerdosClientesBase(id) {
      let sql = await deleteTarifasAcuerdosClientesBase({ id });

      if (!sql.error) {
        // Consulta nuevamente a la API para obtener la nueva data
        let dataTarifasAcuerdosClientesBaseDB = await getAcuerdosClientesBase(
          this.idAux
        );

        // Actualizar los datos del dataTable
        this.actionSetDataListarTarifasAcuerdosClientesBase(
          dataTarifasAcuerdosClientesBaseDB.data_table
        );

        await this.generarBotonesAcciones();

        this.dataTableAux = dataTarifasAcuerdosClientesBaseDB.data_table;

        this.$vToastify.success(
          "Acuerdo de Cliente Base eliminado correctamente",
          "¡Realizado!"
        );
      }
    },
    async publicarDespublicarAcuerdosClientesBySelected( published)  {
      let textToShow = published ? "Publicar": "Despublicar" ;

      const response  = await this.$vToastify.prompt({
        body: `¿Desea ${ textToShow } ${this.acuerdoClientesBaseArreglo.length} Acuerdos Clientes Base?`,
        answers: { Si: true, No: false },
      });

      if (!response) return;

      const form = {
        ids: this.acuerdoClientesBaseArreglo,
        published,
      };

      this.$vToastify.loader("Realizando Solicitud...");

      try {

        await publicarDespublicarAcuerdosClientesByBooleano(form);
        await this.getListaAcuerdosClientesBase();

        this.$vToastify.stopLoader();
        this.limpiarChecks();

        this.$vToastify.success(
          `Acuerdos Clientes Base ${published ? 'Publicados' : 'Despublicados'} correctamente`,
          "¡Realizado!"
        );
      } catch (error) {

        this.$vToastify.stopLoader();

        return this.$vToastify.error(
          "Error al actualizar registros, recargue la página y vuelva a intentar",
          "¡Error!"
        );
      }

    },
    async publicarDespublicarAcuerdosClientesByBooleano(published) {

      let textToShow = published ? "Publicar": "Despublicar" ;
      
      if (this.dataTableAux.length === 0)
        return this.$vToastify.warning(
          "No hay registros para " + textToShow,
          "!Precaución¡"
        );

      const response = await this.$vToastify.prompt({
        body: `¿Desea ${ textToShow } ${this.dataTableAux.length} Acuerdos Clientes Base?`,
        answers: { Si: true, No: false },
      });

      if (!response) return;

      const form = {
        ids: this.dataTableAux.map( d => d.data_complementaria.id),
        published,
      };

      this.$vToastify.loader("Actualizando Registros...");

      try {
        await publicarDespublicarAcuerdosClientesByBooleano(form);
        await this.getListaAcuerdosClientesBase();

        this.$vToastify.stopLoader();
        this.limpiarChecks();

        this.$vToastify.success(
          "Acuerdo Clientes actualizados correctamente",
          "¡Realizado!"
        );
      } catch (error) {
        this.$vToastify.stopLoader();

        return this.$vToastify.error(
          "Error al actualizar registros, recargue la página y vuelva a intentar",
          "¡Error!"
        );
      }
    },
  },
  created() {
    setTimeout(() => {
      this.generarBotonesAcciones();
      this.getDataListas();
    }, 400);
    
  },
  watch: {
    data: function (_new) {
      if (_new) {
        // this.limpiarChecks();
        this.dataTableAux = _new;
        this.acuerdoClientesBaseArreglo = [] ;
        this.generarBotonesAcciones();
      }
    },
  },
};
</script>

<style>
  .z-index-fixed {
    z-index: 5 !important;
  }
</style>
